import React, { Component, useState, useEffect } from 'react'
import APIGenericRequest from '../api/APIGenericRequest'
import APICalendarRequest from '../api/APICalendarRequest'
import APICalendar from '../api/APICalendar'
import '../styles/CalendarView.css'
import DropdownWidget from '../widgets/DropdownWidget'
import Calendar from './Calendar'
import MonthSelector from './MonthSelector'

class CalendarView extends Component
{
	constructor(props) {
		super(props)
		const date = new Date()
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			user: JSON.parse(sessionStorage.getItem("user")),
			monthYear: {month: date.getMonth(), year: date.getFullYear()}
		}
		this.getAllCitiesByProvinceId = this.getAllCitiesByProvinceId.bind(this)
		this.onDateChange = this.onDateChange.bind(this)
		this.onActivityChange = this.onActivityChange.bind(this)
		this.getAllTypesOfActivity = this.getAllTypesOfActivity.bind(this)
		this.onSignal = this.onSignal.bind(this)
		this.getServerDateTime = this.getServerDateTime.bind(this)
	}

	componentWillMount() {
		this.getServerDateTime()
		this.getAllCitiesByProvinceId()
		this.getAllTypesOfActivity()
		console.log('user', this.state.user)
	}

	getServerDateTime() {
		const apiReq = APIGenericRequest.getServerDateTime(this.state.accessToken)
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			const date = new Date(response.results.date_time)
			this.setState({
				date: date,
				monthYear: {month: date.getMonth(), year: date.getFullYear()}
			})
		})
	}

	getAllCitiesByProvinceId() {
		const city = APIGenericRequest.getAllCitiesByProvinceId(this.state.accessToken, this.state.user.province_id);
		city.then((response) => {
			if(response.status === "FAILED") {
				return;
			}
			const c = [];
			for(const v of response.results.rows) {
				c.push({id: v.city_id, name: v.name});
			}
			this.setState({cities: c});
		});
	}

	getAllTypesOfActivity() {
		const types = APICalendarRequest.getAllActivityTypes(this.state.accessToken);
		types.then((response) => {
			if(response.status === "FAILED") {
				return;
			}
			const c = [];
			c.push({id: 0, name: "ALL ACTIVITIES"});
			for(const v of response.results.rows) {
				c.push({id: v.activity_type_id, name: v.name});
			}
			this.setState({typesOfActivity: c});
		});
	}

	onDateChange(year, month) {
		this.setState({monthYear: {month: month, year: year}})
	}

	onActivityChange(id, val) {
		this.setState({activity: {id: id, val: val}})
	}

	onSignal(view, id, stat) {
		this.props.onSignal(view, id, stat) 
	}

	render() {
		const view = <div id="calendar-view">
			<CalendarHeader typesOfActivity={this.state.typesOfActivity}
				onDateChange={this.onDateChange} serverDate={this.state.date}
				onActivityChange={this.onActivityChange} />
			<Calendar viewMonthYear={this.state.monthYear} activity={this.state.activity}
				onSignal={this.onSignal} />
		</div>
		return(view)
	}
}

function CalendarHeader(props) {
	const [month, setMonth] = useState(() => {
		let d = props.serverDate
		if(d == null) {
			d = new Date()
		}
		return(d.getMonth())
	})
	const [year, setYear] = useState(() => {
		let d = props.serverDate
		if(d == null) {
			d = new Date()
		}
		return(d.getFullYear())
	})
	const [serverDate, setServerDate] = useState()
	const [today, setDateToday] = useState()

	function previousMonth() {
		if(month === 0) {
			setYear(prevYear => prevYear - 1)
		}
		setMonth(prevMonth => (prevMonth - 1 < 0)? 11: prevMonth - 1)
	}

	function nextMonth() {
		if(month === 11) {
			setYear(prevYear => prevYear + 1)
		}
		setMonth(prevMonth => (prevMonth + 1 > 11)? 0: prevMonth + 1)
	}

	function setToday() {
		setYear(serverDate.getFullYear())
		setMonth(serverDate.getMonth())
	}

	useEffect(() => {
		getServerDateTime()
	}, [])

	useEffect(() => {
		props.onDateChange(year, month)
	}, [year, month])

	function getServerDateTime() {
		const accessToken = JSON.parse(sessionStorage.getItem("token"))
		const apiReq = APIGenericRequest.getServerDateTime(accessToken)
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				return;
			}
			const date = new Date(response.results.date_time)
			const cMonth = APICalendar.getMonthString(date.getMonth())
			const cDD = date.getDate()
			const cDay = APICalendar.getDayString(date.getDay())
			const today = toTitleCase(cDay) + ", " + toTitleCase(cMonth) + " " + cDD
			setServerDate(date)
			setDateToday(today)
		})
	}

	return(<div id="calendar-header">
		<div id="ch-buttons">
			<div id="ch-buttons-left">
				<button id="chb-today" tooltip={today} tooltip-position="buttom" onClick={setToday}>TODAY</button>
				<MonthSelector list={months} placeholder={APICalendar.getMonthString(month) + " " + year}
					onItemSelected={(id, val, year) => {
						setYear(year)
						setMonth(parseInt(id))
					}} year={year} />
				<div id="prev-btn" tooltip="Previous month" tooltip-position="buttom" onClick={previousMonth}><div id="prev-btn-arrow"></div></div>
				<div id="next-btn" tooltip="Next month" tooltip-position="buttom" onClick={nextMonth}><div id="next-btn-arrow"></div></div>
			</div>
			<div id="ch-buttons-right">
				<DropdownWidget list={props.typesOfActivity} placeholder="ACTIVITY" onItemSelected={(id, val) => {
					props.onActivityChange(id, val)
				}} cStyle={{"width": "210px"}} />
			</div>
		</div>
		<div id="ch-legend">
			<div>LEGEND:</div>
			<div id="done"><span></span>DONE</div>
			<div id="attention"><span></span>NEEDS ATTENTION</div>
			<div id="happening"><span></span>HAPPENING</div>
			<div id="upcoming"><span></span>UPCOMING</div>
		</div>
	</div>)
}

const months = [
	{id: 0, name: "JANUARY"},
	{id: 1, name: "FEBRUARY"},
	{id: 2, name: "MARCH"},
	{id: 3, name: "APRIL"},
	{id: 4, name: "MAY"},
	{id: 5, name: "JUNE"},
	{id: 6, name: "JULY"},
	{id: 7, name: "AUGUST"},
	{id: 8, name: "SEPTEMBER"},
	{id: 9, name: "OCTOBER"},
	{id: 10, name: "NOVEMBER"},
	{id: 11, name: "DECEMBER"},
]

function toTitleCase(str) {
	return str.replace(/\w\S*/g, (txt) => {
		return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	})
}

export default CalendarView
